import axios from "axios";
import toast from "react-hot-toast";

export const baseURL = () => {
  const env = process.env.REACT_APP_PRODUCTION_URL;
  return env;
};

export const api = axios.create({
  baseURL: baseURL(),
});

export const checkCpf = async (cpf) => {
  try {
    return await api.post(`/teachers/check_cpf`, { cpf });
  } catch (error) {
    return error.response;
  }
};

export const checkEmail = async (email) => {
  try {
    return await api.post(`/users/check_email?email=${email}`);
  } catch (error) {
    return error.response;
  }
};

export const createUser = async (data) => {
  try {
    return await api.post(`/teachers`, data);
  } catch (error) {
    return error.response.data;
  }
};

export const checkStudentCpfOrRa = async (data) => {
  try {
    if (data.cpf) {
      return await api.post(`/students/check_cpf`, { cpf: data.cpf });
    } else {
      return await api.post(`/students/check_cpf`, { ra: data.ra });
    }
  } catch (error) {
    return error.response.data;
  }
};

export const createUserAccount = async (userData) => {
  try {
    const { data } = await api.post(`/users/propagate`, userData);
    return data;
  } catch (error) {
    toast.error(error.response?.data?.error || "Erro ao criar conta");
  }
};

export const formatUserData = (data) => {
  const user = {
    name: data.name,
    cpf_cnpj: data.cpf,
    email: data.email,
    profile: data.profile,
    ...(data.serie && {
      connections: Array.isArray(data.serie) ? data.serie : [data.serie],
    }),
    password: data.password,
    password_confirmation: data.confirmPassword,
    user_detail_attributes: {
      phone: data.cellPhone,
      municipality_id: data.municipality,
    },
    terms_of_use: true,
    ...(data.schoolSituation && { academic_status: data.schoolSituation }),
    ...(data.classroom_ids && { classroom_ids: data.classroom_ids }),
    ...(data.course && { course_ids: [data.course] }),
    ...(data.link && { classroom_invitation: data.link }),
  };

  return user;
};

export const resetPassword = async (email) => {
  try {
    return await api.post(`/auth/password`, { email });
  } catch (error) {
    return error.response.data;
  }
};

export const login = async (data) => {
  try {
    const { email, password } = data;
    return await api.post(`/authenticate`, { email, password });
  } catch (error) {
    return error;
  }
};

export const cryptAuthData = (data) => {
  const stringfyData = JSON.stringify(data);
  const encryptedData = btoa(stringfyData);

  return encryptedData;
};
